<style lang="scss" scoped>
div.spinner {
  position: absolute;
  z-index: 1;
  width: 96%;
  height: 70%;
  background-color: rgba(0, 0, 0, 0.5);
}

i.spinner {
  top: 50%;
  position: fixed;
  left: 50%;
}
</style>

<template>
  <div>
    <table-filter
      :filterComponents="[
        {
          type: 'DateRangeFilter',
          name: 'whereDate',
          attributes: { dateField: 'created_at' }
        }
      ]"
      v-model="filter"
      @input="loading = true"
      @apply-filters="$bus.$emit('refresh-table')"
    ></table-filter>
    <div v-if="loading" class="spinner">
      <i class="fas fa-sync fa-7x fa-spin spinner"></i>
    </div>
    <div class="row">
      <div class="col-6">
        <chart-card
          :chart-data="messageChart"
          :chart-options="messageChart.options"
          :chart-height="250"
          chart-type="Pie"
        >
          <template slot="header">
            <h2 class="card-title">Nachrichtentypen</h2>
          </template>
          <template slot="footer">
            <div></div>
          </template>
        </chart-card>
      </div>
      <div class="col-6">
        <v-table
          url="/api/v1/message/count-types"
          :appends="['messagesCount', 'dEType']"
          :filter="filter"
          :attributes="[
            {
              attribute: 'dEType',
              name: 'Typ',
              sortable: false
            },
            {
              attribute: 'typeCount',
              type: 'DoubleValueThousendSeperatCell',
              name: 'Anzahl',
              sortable: false
            },
            {
              secondAttribute: messagesCount,
              type: 'DoubleValuePercentageCell',
              name: 'Anteil',
              sortable: false
            }
          ]"
          ref="table"
          @table-fetched="tableFetched"
        >
          <tr slot="bottom">
            <td>
              <strong>
                Gesamt:
              </strong>
            </td>
            <td>
              <strong>
                {{ messagesCountSpeparated }}
              </strong>
            </td>
            <td></td>
          </tr>
        </v-table>
      </div>
    </div>
  </div>
</template>

<script lang="babel">
import ChartCard from "src/components/UIComponents/Cards/ChartCard";

export default {
  components: {
    ChartCard
  },
  data() {
    return {
      loading: false,
      messagesCount: 0,
      messagesCountSpeparated: 0,
      messageChart: {
        labels: [],
        datasets: [],
        options: {
          legend: {
            display: true
          },
          cutoutPercentage: 50,
          tooltips: {
            enabled: true,
            callbacks: {
              label: (tooltipItem, data) => {
                const formatter = new Intl.NumberFormat('de-DE', {});

                return tooltipItem.yLabel + ' ' + data.labels[tooltipItem.index] +
                  ': ' + formatter.format(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]) +
                  ' ( ' + (formatter.format(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index])
                                  / this.messagesCount
                                  * 100
                          ).toFixed(2) +
                  ' % )';
              }
            }
          }
        }
      },
      filter: [
        {
          name: "whereDate",
          attributes: []
        }
      ]
    }
  },
  methods: {
    tableFetched() {
      this.messageChart = Object.assign({},this.$refs.table.count);
      this.countTypesAndFillChart();
      this.loading = false;
    },
    countTypesAndFillChart(){
      this.messagesCount = 0;
      let labels = [];
      let dataset = {
          label: "Nachrichtentypen",
          pointRadius: 0,
          pointHoverRadius: 0,
          backgroundColor: ["#e3e3e3", "#00f484", "#4acccd", "#56aee2", "#5668e2",
                            "#8a56e2", "#d16be3", "#e25668", "#e02c2c", "#e26a55",
                            "#e28956", "#e2cf55", "#c2e02c"],
          borderWidth: 0,
          data: []
      };

      Object.values(this.messageChart).forEach(values => {
        this.messagesCount += parseInt(values.typeCount, 10);
        labels.push(values.dEType);
        dataset.data.push(values.typeCount);
      });

      this.messagesCountSpeparated = Intl.NumberFormat("de-DE").format(this.messagesCount);

      this.messageChart.labels = labels;
      this.messageChart.datasets = [dataset];
    }
  }
};
</script>
